export default "/assets/website/images/1868.jpeg?b48ca05dde9eb1eba414d5e78d96edd1";